<template>
<!--
============ OBSOLETE FILE ============
-->
    <div class="discover-nav">
        <nav class="navbar navbar-default">
            <ul class="nav">
                <li class="discover-list"
                    v-for="theme in themes"
                    v-if="theme.epigrams"
                    v-track-by="index"
                    tag="li"
                    @mouseover="addClass"
                    >
                  <router-link :to="{ name: 'theme', params: { themeId: theme.id }}"
                               v-bind:data-id="theme.id">
                    <span class="dash">
                      <span class="inner-dash"></span>
                    </span>
                    {{ theme.name }}
                    <sup>{{ theme.id | romanize }}</sup>
                  </router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
/* global theme */

import $ from 'jquery'

export default {
  data: function () {
    return {
      themes: {}
    }
  },
  created: function () {
    this.getThemeData()
  },
  methods: {
    addClass: function (e) {
      $(e.target).addClass('active')
      $(e.target).parent().siblings().children().removeClass('active')
    },
    getThemeData: function () {
      var self = this
      return theme.dataDiscover.get().then(function (response) {
        var data = JSON.parse(response.bodyText)
        self.themes = data.themes
      }, function (response) {
        console.error(response.status, response)
      })
    }
  }
}
</script>

<style lang="sass" scoped>
$hover: .5s all ease-out

.tamere
  color: blue

.discover-nav
  margin-top: 150px
  width: 60%
  padding-left: 20px

  li
    margin: 5px 0

.nav>li>a
  display: flex

ul
  li
    a
      font-size: 17px
      color: #e0e0e0
      align-items: center
      transition: $hover
      padding: 5px 15px 5px 0

      .dash
        width: 20px
        height: 1px
        transition: $hover
        background: transparent
        position: relative
        margin-right: 0
        animation: marginRightOut .5s ease-out forwards

        .inner-dash
          background: #000
          height: 1px
          width: 0
          position: absolute
          top: 0
          left: 0
          transition: $hover
          animation: activeOut .5s ease-out forwards

      sup
        font-size: 9px

      &.active
        color: #2c2c2c
        background: none

        .dash
          animation: marginRightIn .5s ease-out .2s forwards

          .inner-dash
            animation: activeIn .5s ease-out forwards

@keyframes activeIn
  from
    width: 0

  to
    width: 20px

@keyframes activeOut
  from
    width: 20px

  to
    width: 0

@keyframes marginRightIn
  from
    margin-right: 0

  to
    margin-right: 10px

@keyframes marginRightOut
  from
    margin-right: 10px

  to
    margin-right: 0
</style>



// WEBPACK FOOTER //
// DiscoverNav.vue?32c905bc